class EqualHeights {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-equal-heights="scope"]',
			item: '[data-equal-heights="item"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.setHeight();
		this.addEventListeners();
	}

	addEventListeners() {
		$(window).resize(() => this.removeHeight());
		$(window).resize(() => this.setHeight());
	}

	removeHeight() {
		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			$scope.find(this.config.item).css('height', '');
		})
	}

	setHeight() {
		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			this.$scope.each((index, scope) => {
				let $scope = $(scope);
				let $items = $scope.find(this.config.item);
				let height = 0;

				$items.each((index, item) => {
					let $item = $(item);
					if($item.outerHeight() > height) {
						height = $item.outerHeight();
					}
				});

				$items.css('height', height + 'px');
			})
		}, 300);
	}
}

export default EqualHeights;